// extracted by mini-css-extract-plugin
export default {"navigation":"PersonalAccount_navigation__thWmK","navigationButton":"PersonalAccount_navigationButton__oW4jd","actions":"PersonalAccount_actions__Py3+r"};